import LinkButton, { LinkButtonProps } from '@/components/atoms/linkButton';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';

import { removeEmptyKeys } from '@/utils/removeEmptyKeys';

export interface LinkButtonSBProps {
  text?: string;
  url: string;
  openInNewTab?: boolean;
  variant?: LinkButtonProps['variant'];
  color?: LinkButtonProps['color'];
}

export function transformFromCMSLink(block: LinkButtonSBProps) {
  const { url, openInNewTab, ...restBlock } = block;

  const updatedHref = url?.replace(currentLocaleConfig().url, '');

  return removeEmptyKeys({
    ...restBlock,
    target: openInNewTab ? '_blank' : undefined,
    href: updatedHref || '#',
  }) as LinkButtonProps;
}

export default function LinkButtonSB({
  block,
  inner,
}: BlockComponentModel<LinkButtonSBProps, LinkButtonProps>) {
  const props = transformFromCMSLink(block);

  return (
    <LinkButton {...(props as LinkButtonProps)} {...inner}>
      {block.text}
    </LinkButton>
  );
}
